<template>
  <modal
    class="editTruck"
    name="updateOrderStatus"
    transition="pop-out"
    :width="modalWidth"
    :height="450"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.updateOrderStatusModal.setStatus") }}
        </h3>

        <div class="sign_up_form_section">
          <form style="margin: 0 auto; width: 70%">
            <div class="row">
              <div class="col-md-12">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.updateOrderStatusModal.comment") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$t('text.updateOrderStatusModal.comment')"
                    v-model="comment"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-12">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.updateOrderStatusModal.orderStatus") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <select v-model="order.status">
                    <option value="Driver Assigned">
                      {{ $t("text.updateOrderStatusModal.driverAssigned") }}
                    </option>
                    <option value="Payment Pending">
                      {{ $t("text.updateOrderStatusModal.paymentPending") }}
                    </option>
                    <option value="Payment Completed">
                      {{ $t("text.updateOrderStatusModal.paymentCompleted") }}
                    </option>
                    <option value="Payment Confirmed">
                      {{ $t("text.updateOrderStatusModal.paymentConfirmed") }}
                    </option>
                    <option value="Order Completed">
                      {{ $t("text.updateOrderStatusModal.orderCompleted") }}
                    </option>
                    <option value="Order Accepted">
                      {{ $t("text.updateOrderStatusModal.orderAccepted") }}
                    </option>
                    <option value="Order Rejected">
                      {{ $t("text.updateOrderStatusModal.orderRejected") }}
                    </option>
                    <option value="Processing">
                      {{ $t("text.updateOrderStatusModal.processing") }}
                    </option>
                    <option value="In Transit">
                      {{ $t("text.updateOrderStatusModal.inTransit") }}
                    </option>
                    <option value="Arrived">
                      {{ $t("text.updateOrderStatusModal.arrived") }}
                    </option>
                    <option value="Owner Accepted">
                      {{ $t("text.updateOrderStatusModal.ownerAccepted") }}
                    </option>
                    <option value="Fill Started">
                      {{ $t("text.updateOrderStatusModal.fillStarted") }}
                    </option>
                    <option value="Fill Ended">
                      {{ $t("text.updateOrderStatusModal.fillEnded") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="updateOrderstatus($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.updateOrderStatusModal.title") }} <span></span>
              </button>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "updateOrderstatus",
  props: ["order"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      comment: "",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeOrderStatusUpdateModal() {
      this.$modal.hide("updateOrderStatus");
    },
    updateOrderstatus($event) {
      $event.preventDefault();
      if (!this.comment) {
        this.$toast.open({
          message: this.$t("text.updateOrderStatusModal.commentMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      let data = {
        orderId: parseInt(this.order.id),
        comment: this.comment,
        status: this.order.status,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/OrderFulfilment/UpdateOrderStatus`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeOrderStatusUpdateModal();
          this.comment = "";
          this.$toast.open({
            message: this.$t("text.updateOrderStatusModal.successfullyUpdated"),
            type: "success",
            duration: 5000,
          });
          this.$eventHub.$emit("getTrucks");
          data = null;
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.closeOrderStatusUpdateModal();
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
